import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pager({ offset, limit, total, onChange, testid = "pager" }) {
  if (total <= limit) return null;
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);

  return (
    <div
      className="flex items-center justify-between gap-3 px-4 py-3 border-t border-[#E8DFD1] bg-[#FAF6F0]"
      data-testid={testid}
    >
      <span className="text-xs text-[#8C7A6B]" data-testid={`${testid}-range`}>
        Showing <span className="font-semibold text-[#2A1810]">{from}–{to}</span> of{" "}
        <span className="font-semibold text-[#2A1810]">{total}</span>
      </span>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onChange(Math.max(0, offset - limit))}
          disabled={offset === 0}
          data-testid={`${testid}-prev`}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-semibold border border-[#E8DFD1] bg-white text-[#2A1810] hover:border-[#C5A059] disabled:opacity-40 disabled:hover:border-[#E8DFD1] transition-colors"
        >
          <ChevronLeft size={13} /> Prev
        </button>
        <button
          onClick={() => onChange(offset + limit)}
          disabled={to >= total}
          data-testid={`${testid}-next`}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-semibold border border-[#E8DFD1] bg-white text-[#2A1810] hover:border-[#C5A059] disabled:opacity-40 disabled:hover:border-[#E8DFD1] transition-colors"
        >
          Next <ChevronRight size={13} />
        </button>
      </div>
    </div>
  );
}
